import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefinitionComponent } from './definition/definition.component';
import { IactComponent } from './iact.component';
import { IacctListComponent } from './iact-list/iact-list.component';
import { IactListIndexComponent } from './iact-list/iact-list-index.component';
import { ExternalComponent } from './external/external.component';
import { IacctRangeResolver, IacctsByRangeResolver } from './resolvers'
import { AcquisitionsComponent } from './acquisitions/acquisitions.component';

const routes: Routes = [
  { path: '', component: IactComponent },
  { path: 'iact-definition', component: DefinitionComponent },
  {
    path: 'iact-list',
    component: IactListIndexComponent,
    data: { title: 'Institutional Accounts' },
    resolve: {iacctRanges: IacctRangeResolver}
  },
  {
    path: 'iact-list/:rangeId',
    component: IacctListComponent,
    data: { title: 'Institutional Accounts' },
    resolve: { iacctRanges: IacctRangeResolver, iaccts: IacctsByRangeResolver}
  },
  {
    path: 'iact-memos',
    component: ExternalComponent,
  },
  {
    path: 'acquisitions',
    component: AcquisitionsComponent
  },
  {
    path: 'iact-FY17-FY18',
    component: ExternalComponent,
    data: { title: 'FY17-FY18' },
  },
  {
    path: 'iact-FY16',
    component: ExternalComponent,
    data: { title: 'FY16' },
  },
  {
    path: 'iact-afr-2015',
    component: ExternalComponent,
    data: { title: 'afr-2015' },
  },
  {
    path: 'iact-afr-2014',
    component: ExternalComponent,
    data: { title: 'afr-2014' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IactRoutingModule {}
